import { useCallback } from "react";
import { useNavigate } from "react-router";
import { REPORT_DETAIL_STORE_INSTANCE } from "~/store/details";

export function useNavigationGuard() {
  const navigate = useNavigate();
  const {
    selectors: { useHasPendingChanges, useIsAutoSaveEnabled },
    events: { clearPendingChanges },
  } = REPORT_DETAIL_STORE_INSTANCE;
  const hasPendingChanges = useHasPendingChanges();
  const shouldBlockNavigation = hasPendingChanges;

  const navigateWithGuard = useCallback(
    (path: string, onNavigate?: () => void) => {
      if (shouldBlockNavigation) {
        return false;
      }
      onNavigate?.();
      navigate(path);
      return true;
    },
    [shouldBlockNavigation, navigate]
  );

  return {
    shouldBlockNavigation,
    navigateWithGuard,
    clearPendingChanges,
  };
}
